module.exports = __webpack_public_path__ + "img/copy-02.22d7aad0.svg";